export const NotAllowedPage = () => (
     <div className="container content">
        <div className="p-3 mt-5 shadow rounded mt-4">
           <h1>You are not allowed to this content</h1>
        </div>
     </div>
)